import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalDrawService {
  validForm: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  confirmButton: Subject<any> = new Subject();

  constructor() {}

  formularioValido(isValid: boolean) {
    this.validForm.next(isValid);
  }

  onButtonConfirm() {
    this.confirmButton.next(1);
  }
}
